export default __webpack_public_path__ + "static/partnerColorIcon14-d9eed9ac653ebd775395ebc66be6bc4c.svg";